<span class="skip" [routerLink]="" tabindex="0" [attr.aria-label]="'aria_label.main_content'|translate" role="region"
    (click)="skipToMain()" (keyup.enter)="skipToMain()">
    <h6 class="skip-link"> Skip to Main Content</h6>
</span>
<nav class="navbar navbar-expand-lg bg-light" id="header">

    <div class="container-fluid rvh-header-container-fluid" #hideNavOnScroll>
        <a class="d-block d-lg-none d-flex justify-content-left pl-0 mt-1" href="https://www.thebritishacademy.ac.uk/"
            target="_blank" routerLinkActive="active" title="Journal logo">
            <!-- <div *ngIf="loading_image" class="spinner"></div> -->
            <img fetchpriority="high" src="assets/logos/jba_logo.webp" class="logo-image" alt="BA Logo">
            <!--[alt]="themeSettingsData.logo_alt_text" {{publisherLogo}}-->
        </a>
        <div class="d-flex justify-content-between align-items-center">
            <a class="ps-3 pe-3 navbar-toggler rss-feed-new" [href]="rss_url" target="_blank" role="link"
                aria-label="RSS feed" title="RSS Feed" [ngbTooltip]="'app_header.rss_feed'|translate"
                [placement]="'bottom'">
                <fa-icon aria-hidden="true" [icon]="['fas','square-rss']"></fa-icon>
            </a>
            <button class="navbar-toggler" type="button" (click)="showSearchBar()" aria-label="Search"
                (keyup.enter)="showSearchBar()" (keyup.space)="showSearchBar()">
                <span class="nav-breadcrum"><fa-icon [icon]="['fas','search']" aria-hidden="true"></fa-icon></span>
            </button>
            <button class="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar"
                role="button" aria-label="toggle bar" aria-controls="offcanvasNavbar" (click)="getOffcanvas()"
                (keyup.enter)="getOffcanvas()" (keyup.space)="getOffcanvas()">
                <span class="nav-breadcrum"><fa-icon [icon]="['fas','bars']" aria-hidden="true"></fa-icon></span>
            </button>
        </div>

        <div class="offcanvas offcanvas-end" id="offcanvasNavbar" tabindex="-1" role="navigation">
            <div class="offcanvas-header pb-0">
                <a href="https://www.thebritishacademy.ac.uk/" target="_blank" routerLinkActive="active"
                    *ngIf="isSmallScreen" title="Journal Logo">
                    <!-- <div *ngIf="loading_image" class="spinner"></div> -->
                    <img fetchpriority="high" src="assets/logos/jba_logo.webp" class="logo-image" alt="BA Logo">
                    <!--[alt]="themeSettingsData.logo_alt_text" {{publisherLogo}}-->
                </a>
                <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>
            <div class="offcanvas-body pt-0">
                <!-- Your code here -->
                <!-- Include your code here -->
                <nav class="row w-100" role="navigation" aria-label="navigation">
                    <div class="col-lg-2 col-md-12 col-sm-12 d-sm-flex align-items-center justify-content"
                        *ngIf="!isSmallScreen">
                        <div class="logo-image-div">
                            <a href="https://www.thebritishacademy.ac.uk/" target="_blank" routerLinkActive="active"
                                title="Journal Logo">
                                <!-- <div *ngIf="loading_image" class="spinner"></div> -->
                                <img fetchpriority="high" src="assets/logos/jba_logo.webp" class="logo-image"
                                    alt="BA Logo">
                                <!--[alt]="themeSettingsData.logo_alt_text" {{publisherLogo}}-->
                            </a>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12 col-sm-12 align-items-center pl-0">

                        <!-- UL items content here -->
                        <ul class="navbar-nav rvh-jnl-book-menus primary-header">
                            <li class="nav-item pl-5 ml-2">
                                <a data-bs-dismiss="offcanvas" class="nav-link-primary rvh-menu-label"
                                    title="{{'app_header.journals_jba' | translate}}" *ngIf="journalData.length > 0"
                                    [routerLink]="['']">
                                    {{'app_header.journals_jba' | translate}}

                                </a>
                                <!-- <a data-bs-dismiss="offcanvas" class="nav-link-primary rvh-menu-label loader"
                                    *ngIf="journalData.length === 0" [routerLink]="['']">
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </a> -->
                            </li>
                            <!-- <li class="nav-item" *ngIf="journalRetiredData.length > 0 || journalCurrentData.length >0">
                                <a class="nav-link " data-bs-dismiss="offcanvas" routerLink="/proceedings"
                                    class="rvh-menu-label">
                                    {{'app_header.proceedings' | translate}}
                                </a>
                            </li> -->
                            <!-- <li class="nav-item"
                                *ngIf="journalRetiredData.length === 0 || journalCurrentData.length ===0">
                                <a class="nav-link loader" data-bs-dismiss="offcanvas" routerLink="/proceedings"
                                    class="rvh-menu-label">
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </a>
                            </li> -->

                            <!-- <li class="nav-item" *ngIf="journalRetiredData.length > 0 || journalCurrentData.length >0">
                                <a class="nav-link " data-bs-dismiss="offcanvas" routerLink="/proceedings"
                                    class="rvh-menu-label">
                                    {{'app_header.proceedings' | translate}}
                                </a>
                            </li> -->

                            <!-----------------------------------------------for screen size below 992----------------------------------------->
                            <li class="nav-item pl-5 ml-2" *ngIf="isSmallScreen">
                                <span class=" nav-link-primary" (click)="about_isCollapsed = !about_isCollapsed; "
                                    [attr.aria-expanded]="!about_isCollapsed" aria-controls="collapseExample"
                                    title="{{ 'app_header.about' | translate }}">
                                    <!--------------[routerLink]="about_url"-->
                                    {{ 'app_header.about' | translate }}
                                    <fa-icon [icon]="['fas','angle-down']" *ngIf="!about_isCollapsed"></fa-icon>
                                    <fa-icon [icon]="['fas','angle-right']" *ngIf="about_isCollapsed"></fa-icon>
                                </span>
                                <div #collapse="ngbCollapse" [(ngbCollapse)]="about_isCollapsed">
                                    <ul>
                                        <li *ngFor="let data of dynamic_menus_journal" class="nav-item pl-0">
                                            <a class="nav-link" tabindex="0" [attr.aria-label]="data.pageName"
                                                data-bs-dismiss="offcanvas" title="{{ data.pageName }}"
                                                [routerLink]="data.pageId === 'editorialboard' ? '/editorial-board' : '/content/' + data.page_identifier">
                                                {{ data.pageName }}
                                            </a>
                                        </li>
                                        <li *ngIf="dynamic_menus_journal.length ===0" class="nav-item ">
                                            <span class="nav-link loader mt-2" style="width: 100%; height:1rem"
                                                tabindex="0" [attr.aria-label]="">
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            </span>
                                        </li>
                                        <li *ngIf="dynamic_menus_journal.length === 0" class="nav-item">
                                            <span class="nav-link loader" style="width: 100%; height:1rem;" tabindex="0"
                                                [attr.aria-label]="">
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            </span>
                                        </li>
                                        <li *ngIf="dynamic_menus_journal.length === 0" class="nav-item">
                                            <span class="nav-link loader" style="width: 100%; height:1rem;" tabindex="0"
                                                [attr.aria-label]="">
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            </span>
                                        </li>
                                        <li *ngIf="dynamic_menus_journal.length === 0" class="nav-item">
                                            <span class="nav-link loader" tabindex="0" style="width: 100%; height:1rem;"
                                                [attr.aria-label]="">
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            </span>
                                        </li>
                                        <li *ngIf="!dynamicMenuData" class="nav-item  pl-0">
                                            <a class="nav-link" tabindex="0"
                                                title="{{ 'journal_home.Editorial_heading' | translate }}"
                                                [routerLink]="'/editorial-board'">
                                                {{ 'journal_home.Editorial_heading' | translate }}
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" title="Contact us" *ngIf="contactStatus===true"
                                                tabindex="0" [routerLink]="'/contact'">Contact
                                                Us</a>
                                        </li>
                                    </ul>
                                </div>
                            </li>

                            <li class="nav-item pl-3" *ngIf="isSmallScreen">
                                <span class=" nav-link-primary pl-3"
                                    (click)="article_isCollapsed = !article_isCollapsed ;"
                                    [attr.aria-expanded]="!article_isCollapsed" aria-controls="collapseExample"
                                    title="{{ 'app_header.articles_jba' | translate }}">
                                    {{ 'app_header.articles_jba' | translate }}
                                    <fa-icon [icon]="['fas','angle-down']" *ngIf="!article_isCollapsed"></fa-icon>
                                    <fa-icon [icon]="['fas','angle-right']" *ngIf="article_isCollapsed"></fa-icon>
                                </span>
                                <div #collapse="ngbCollapse" [(ngbCollapse)]="article_isCollapsed">
                                    <ul>
                                        <li class="nav-item">
                                            <a class="nav-link" [routerLink]="[ 'volumes']" tabindex="0"
                                                data-bs-dismiss="offcanvas"
                                                title="{{ 'journal_listing.volume_issue'|translate }}">
                                                {{'journal_listing.volume_issue'|translate }}</a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" [routerLink]="['current-articles']" tabindex="0"
                                                data-bs-dismiss="offcanvas"
                                                title="{{ 'app_header.current_articles_jba' | translate }}">
                                                {{ 'app_header.current_articles_jba' | translate }}</a>
                                        </li>

                                        <li class="nav-item">
                                            <a class="nav-link" [routerLink]="[ 'thematic-collections']"
                                                data-bs-dismiss="offcanvas" tabindex="0"
                                                title=" {{ 'app_header.special_issues_jba' | translate }}">
                                                {{ 'app_header.special_issues_jba' | translate }}
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </li>

                            <li class="nav-item pl-3" *ngIf="isSmallScreen">
                                <span class="nav-link-primary pl-3"
                                    (click)="submit_article_isCollapsed = !submit_article_isCollapsed;"
                                    [attr.aria-expanded]="!submit_article_isCollapsed" aria-controls="collapseExample"
                                    title="{{'app_header.submit_articles_jba' | translate}}">
                                    {{'app_header.submit_articles_jba' | translate}}
                                    <fa-icon [icon]="['fas','angle-down']"
                                        *ngIf="!submit_article_isCollapsed"></fa-icon>
                                    <fa-icon [icon]="['fas','angle-right']"
                                        *ngIf="submit_article_isCollapsed"></fa-icon>
                                </span>
                                <div #collapse="ngbCollapse" [(ngbCollapse)]="submit_article_isCollapsed">
                                    <ul>
                                        <li *ngIf="!inst_authors_name" class="nav-item">
                                            <span class="nav-link loader" style="width: 100%; height:1rem;" tabindex="0"
                                                [attr.aria-label]="">
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            </span>
                                        </li>
                                        <li *ngIf="!inst_guest_name" class="nav-item">
                                            <span class="nav-link loader" style="width: 100%; height:1rem;" tabindex="0"
                                                [attr.aria-label]="">
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            </span>
                                        </li>
                                        <li *ngIf="art_sub_name" class="nav-item">
                                            <a class="dropdown-item" [routerLink]="art_sub_url" title="{{art_sub_name}}"
                                                data-bs-dismiss="offcanvas">{{art_sub_name}}</a>

                                        </li>
                                        <li *ngIf="inst_authors_name" class="nav-item">
                                            <a class="dropdown-item" [routerLink]="inst_authors_url"
                                                title="{{inst_authors_name}}"
                                                data-bs-dismiss="offcanvas">{{inst_authors_name}}</a>

                                        </li>
                                        <li *ngIf="inst_guest_name" class="nav-item">
                                            <a data-bs-dismiss="offcanvas" class="dropdown-item"
                                                [routerLink]="inst_guest_url" data-bs-dismiss="offcanvas"
                                                title="{{inst_guest_name}}">{{inst_guest_name}}</a>

                                        </li>
                                        <li *ngIf="prod_art_name" class="nav-item">
                                            <a data-bs-dismiss="offcanvas" class="dropdown-item"
                                                [routerLink]="prod_art_url" data-bs-dismiss="offcanvas"
                                                title="{{prod_art_name}}">{{prod_art_name}}</a>
                                        </li>
                                        <li *ngIf="promo_art_name" class="nav-item">
                                            <a data-bs-dismiss="offcanvas" class="dropdown-item"
                                                [routerLink]="promo_art_url" data-bs-dismiss="offcanvas"
                                                title="{{promo_art_name}}">{{promo_art_name}}</a>
                                        </li>
                                        <li *ngIf="inf_pol_name" class="nav-item">
                                            <a data-bs-dismiss="offcanvas" class="dropdown-item"
                                                [routerLink]="inf_pol_url" data-bs-dismiss="offcanvas"
                                                title="{{inf_pol_name}}">{{inf_pol_name}}</a>

                                        </li>



                                    </ul>
                                </div>
                            </li>
                            <div class="row " *ngIf="accoutWishCart">
                                <div class="col d-flex justify-content-center">
                                    <div class="icon-head-div " *ngIf="!islogined">
                                        <fa-icon aria-hidden="true" [icon]="['far', 'user']"
                                            class="p-2 pb-0 user-icon-size "></fa-icon>
                                        <span class="icon-text">{{'app_header.account' | translate}}</span>
                                    </div>
                                    <div class="icon-head-div " *ngIf="islogined">
                                        <img [src]="profile_picture" [alt]="'app_header.profile_picture'|translate"
                                            class="user_image">
                                        <span class="icon-text">{{'app_header.account' | translate}}</span>
                                    </div>

                                    <div class="icon-head-div">
                                        <fa-icon icon="heart" aria-hidden="true" class="user-icon-size "></fa-icon>
                                        <span class="icon-text">
                                            <span tabindex="0" role="link"
                                                title="{{'app_header.wishlist' | translate}}">{{'app_header.wishlist'
                                                |
                                                translate}}</span>
                                        </span>
                                    </div>
                                    <div class="icon-head-div d-flex">
                                        <fa-icon aria-hidden="true" icon="cart-shopping" class="user-icon-size">
                                        </fa-icon>
                                        <span class="cst-cart-count"> {{ itemsInCart }}</span>
                                        <div class="cart-text">
                                            <span tabindex="0" role="link" title="{{'app_header.cart' | translate}}">
                                                {{'app_header.cart' |
                                                translate}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!---------------------------------------------------------------------------------------------------------------------------->
                            <!--------------------------------------for screen size above 992--------------------------------------------------------------------------->
                            <li class="nav-item dropdown" (mouseenter)="openDropdown('about')" *ngIf="!isSmallScreen"
                                (mouseleave)="closeDropdown('about')">
                                <span class="dropdown-toggle nav-link-primary pl-3" role="button"
                                    aria-haspopup="listbox" id="dropdownMenuLinkAbout" data-bs-toggle="dropdown" tabindex="0"
                                    aria-expanded="false" title="{{ 'app_header.about' | translate }}">{{
                                    'app_header.about' | translate }}
                                    <!---------------------[routerLink]="about_url"-->
                                </span>
                                <ul class="dropdown-menu p-0" role="listbox" aria-labelledby="dropdownMenuLinkAbout"
                                    aria-expanded="false" #dropdownMenuAbout>
                                    <li *ngFor="let data of dynamic_menus_journal" role="option">
                                        <a class="dropdown-item" tabindex="0" [attr.aria-label]="data.pageName"
                                            data-bs-dismiss="offcanvas" title="{{ data.pageName }}"
                                            [routerLink]="data.pageId === 'editorialboard' ? '/editorial-board' : '/content/' + data.page_identifier">
                                            {{ data.pageName }}
                                        </a>
                                    </li>
                                    <li *ngIf="dynamic_menu_loader" role="option">
                                        <span class="dropdown-item loader mt-2" style="width: 100%; height:1rem"
                                            tabindex="0" [attr.aria-label]="">
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span>
                                    </li>
                                    <li *ngIf="dynamic_menu_loader" role="option">
                                        <span class="dropdown-item loader" style="width: 100%; height:1rem;"
                                            tabindex="0" [attr.aria-label]="">
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span>
                                    </li>
                                    <li *ngIf="dynamic_menu_loader" role="option">
                                        <span class="dropdown-item loader" style="width: 100%; height:1rem;"
                                            tabindex="0" [attr.aria-label]="">
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span>
                                    </li>
                                    <li *ngIf="dynamic_menu_loader" role="option">
                                        <span class="dropdown-item loader" tabindex="0"
                                            style="width: 100%; height:1rem;" [attr.aria-label]="">
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span>
                                    </li>
                                    <li *ngIf="!dynamicMenuData && dynamic_menu_loader" role="option">
                                        <a data-bs-dismiss="offcanvas" class="dropdown-item" tabindex="0"
                                            title="{{ 'journal_home.Editorial_heading' | translate }}"
                                            [routerLink]="'/editorial-board'">
                                            {{ 'journal_home.Editorial_heading' | translate }}
                                        </a>
                                    </li>
                                    <li>
                                        <a data-bs-dismiss="offcanvas" class="dropdown-item" data-bs-dismiss="offcanvas"
                                            title="Contact us" *ngIf="contactStatus===true" tabindex="0"
                                            [routerLink]="'/contact'">Contact
                                            Us</a>
                                    </li>
                                </ul>
                            </li>

                            <li class="nav-item dropdown" (mouseenter)="openDropdown('articles')" *ngIf="!isSmallScreen"
                                (mouseleave)="closeDropdown('articles')">
                                <span class="dropdown-toggle nav-link-primary pl-3" role="button" tabindex="0"
                                    aria-haspopup="listbox" id="dropdownMenuArticle" data-bs-toggle="dropdown"
                                    aria-expanded="false" title="{{ 'app_header.articles_jba' | translate }}">
                                    {{ 'app_header.articles_jba' | translate }}
                                </span>
                                <ul class="dropdown-menu p-0" role="listbox" aria-labelledby="dropdownMenuLinkArticle"
                                    aria-expanded="false">
                                    <li>
                                        <a class="dropdown-item" [routerLink]="[ 'volumes']" tabindex="0"
                                            data-bs-dismiss="offcanvas"
                                            title="{{ 'journal_listing.volume_issue'|translate }}">
                                            {{'journal_listing.volume_issue'|translate }}</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" [routerLink]="['current-articles']" tabindex="0"
                                            data-bs-dismiss="offcanvas"
                                            title="{{ 'app_header.current_articles_jba' | translate }}">
                                            {{ 'app_header.current_articles_jba' | translate }}</a>
                                    </li>
                                    <!-- <li>
                                     <a class="dropdown-item" [routerLink]="clustered_url" tabindex="0">{{
                                         clustered_name }}</a>
                                 </li> -->
                                    <li>
                                        <a class="dropdown-item" [routerLink]="[ 'thematic-collections']"
                                            data-bs-dismiss="offcanvas" tabindex="0"
                                            title=" {{ 'app_header.special_issues_jba' | translate }}">
                                            {{ 'app_header.special_issues_jba' | translate }}
                                        </a>
                                    </li>
                                </ul>
                            </li>

                            <li class="nav-item dropdown" (mouseenter)="openDropdown('SubmitArticles')"
                                *ngIf="!isSmallScreen" (mouseleave)="closeDropdown('SubmitArtiScles')">
                                <span class="dropdown-toggle nav-link-primary pl-3" role="button"
                                    aria-haspopup="listbox" id="dropdownMenuLinkSubmit" data-bs-toggle="dropdown" tabindex="0"
                                    aria-expanded="false" title="{{'app_header.submit_articles_jba' | translate}}">
                                    {{'app_header.submit_articles_jba' | translate}}
                                </span>
                                <ul class="dropdown-menu p-0" role="listbox" aria-labelledby="dropdownMenuLinkSubmit"
                                    aria-expanded="false">
                                    <li *ngFor="let data of dynamic_menus_author" role="option">
                                        <a class="dropdown-item" tabindex="0" [attr.aria-label]="data.pageName"
                                            data-bs-dismiss="offcanvas" title="{{ data.pageName }}"
                                            [routerLink]="'/content/' + data.page_identifier">
                                            {{ data.pageName }}
                                        </a>
                                    </li>
                                    <!-- <li *ngIf="!inst_authors_name">
                                        <span class="nav-link loader" style="width: 100%; height:2rem;" tabindex="0"
                                            [attr.aria-label]="">
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span>
                                    </li>
                                    <li *ngIf="!inst_guest_name">
                                        <span class="nav-link loader" style="width: 100%; height:2rem;" tabindex="0"
                                            [attr.aria-label]="">
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span>
                                    </li>
                                    <li *ngIf="!inst_authors_name">
                                        <span class="nav-link loader" style="width: 100%; height:2rem;" tabindex="0"
                                            [attr.aria-label]="">
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span>
                                    </li>
                                    <li *ngIf="!inst_guest_name">
                                        <span class="nav-link loader" style="width: 100%; height:2rem;" tabindex="0"
                                            [attr.aria-label]="">
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span>
                                    </li>
                                    <li *ngIf="art_sub_name">
                                        <a class="dropdown-item" [routerLink]="art_sub_url"
                                            title="{{art_sub_name}}"
                                            data-bs-dismiss="offcanvas">{{art_sub_name}}</a>

                                    </li>
                                    <li *ngIf="inst_authors_name">
                                        <a class="dropdown-item" [routerLink]="inst_authors_url"
                                            title="{{inst_authors_name}}"
                                            data-bs-dismiss="offcanvas">{{inst_authors_name}}</a>

                                    </li>
                                    <li *ngIf="inst_guest_name">
                                        <a data-bs-dismiss="offcanvas" class="dropdown-item"
                                            [routerLink]="inst_guest_url" data-bs-dismiss="offcanvas"
                                            title="{{inst_guest_name}}">{{inst_guest_name}}</a>

                                    </li>
                                    <li *ngIf="prod_art_name">
                                        <a data-bs-dismiss="offcanvas" class="dropdown-item" [routerLink]="prod_art_url"
                                            data-bs-dismiss="offcanvas" title="{{prod_art_name}}">{{prod_art_name}}</a>
                                    </li>
                                    <li *ngIf="promo_art_name">
                                        <a data-bs-dismiss="offcanvas" class="dropdown-item"
                                            [routerLink]="promo_art_url" data-bs-dismiss="offcanvas"
                                            title="{{promo_art_name}}">{{promo_art_name}}</a>
                                    </li>
                                    <li *ngIf="inf_pol_name">
                                        <a data-bs-dismiss="offcanvas" class="dropdown-item" [routerLink]="inf_pol_url"
                                            data-bs-dismiss="offcanvas" title="{{inf_pol_name}}">{{inf_pol_name}}</a>

                                    </li> -->
                                    <!-- <li>
                                     <a data-bs-dismiss="offcanvas" class="dropdown-item"
                                         [routerLink]="sub_info_url">{{sub_info_name}}</a>

                                 </li> -->
                                    <!-- <li>
                                     <a data-bs-dismiss="offcanvas" class="dropdown-item"
                                         [routerLink]="permission_url">{{permission_name}}</a>

                                 </li> -->

                                    <!-- <li >
                     <a class="dropdown-item"  [routerLink]="ref_url">{{ref_name}}</a>

                 </li> -->
                                </ul>
                            </li>
                            <!-------------------------------------------------------------------------------------------------------------------------->
                        </ul>
                        <div class="user-account-sec d-flex justify-content-center media-icon d-block d-lg-none">
                            <!-- responcive icons -->
                            <!-- <ng-container *ngIf="returnSocialMedia(journalSettingData).length>0">
                                <a data-bs-dismiss="offcanvas"
                                    *ngFor="let media of returnSocialMedia(journalSettingData)"
                                    class="navbar-brand navbar-brand-secondary-icons" target="_blank"
                                    [href]="ensureHttps(media.value)" role="link"
                                    [attr.aria-label]="'vist link'+ media.value" [ngbTooltip]="media.label"
                                    [placement]="'bottom'">
                                    <fa-icon aria-hidden="true" [icon]="media.icon"></fa-icon>
                                </a>
                            </ng-container>
                            <a data-bs-dismiss="offcanvas"
                                class="navbar-brandnavbar-brand-secondary-icons media-content-rss" [href]="rss_url"
                                target="_blank" role="link" [ngbTooltip]="'app_header.rss_feed'|translate"
                                [placement]="'bottom'" aria-label="RSS feed">
                                <fa-icon aria-hidden="true" [icon]="['fas','square-rss']"></fa-icon>
                            </a> -->

                        </div>
                    </div>

                    <!-- Search bar -->
                    <div class="col-lg-4 col-md-12 col-sm-12 " *ngIf="!isSmallScreen">
                        <div class="d-flex header-search-and-social-media-section">
                            <div class="search-div-header d-none d-lg-block">
                                <form class="form-inline " [formGroup]="searchForm" role="search">
                                    <div class="input-group search-box primary-header search-content">
                                        <div class="search-icon-div">
                                            <span id="basic-addon1">
                                                <fa-icon [icon]="['fas','magnifying-glass']"
                                                    aria-hidden="true"></fa-icon>
                                            </span>
                                        </div>
                                        <input type="text"
                                            class="form-control search-box-input-control mt-0 search-input-header"
                                            autocomplete="off" name="searchValue"
                                            placeholder="{{'app_header.search_placeholder_jba'|translate }}"
                                            formControlName="searchValue" (keyup)="searchArticle()"
                                            (keyup.enter)="loadArticlePage()" (click)="searchArticle()"
                                            data-bs-toggle="dropdown" id="dropdownMenuButton" tabindex="0"
                                            (focusout)="searchLoader = false;">
                                        <span class="closeMark" *ngIf="!searchLoader && searchData?.searchValue?.value"
                                            (click)="clearSearch()" (keyup.enter)="clearSearch()"
                                            (keyup.space)="clearSearch()" tabindex="0">
                                            <fa-icon aria-hidden="true" [icon]="['fas', 'xmark']" class=""></fa-icon>
                                        </span>
                                        <div *ngIf="searchLoader">
                                            <div class="spinner-border"></div>
                                        </div>
                                        <ul class="search-dropdown dropdown-menu" style="left: -2rem;" role="search">
                                            <ng-container *ngIf="loading">
                                                <li>
                                                    <div class="search-article-title loader" tabindex="0">
                                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    </div>
                                                    <div class="nav-search-doi loader" style="width: 50%;" tabindex="0">
                                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    </div>
                                                    <span class='activeSemicolumn loader' style="width: 25%;"
                                                        tabindex="0">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                </li>
                                                <li>
                                                    <div class="search-article-title loader" tabindex="0">
                                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    </div>
                                                    <div class="nav-search-doi loader" style="width: 50%;" tabindex="0">
                                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    </div>
                                                    <span class='activeSemicolumn loader' style="width: 25%;"
                                                        tabindex="0">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                </li>
                                            </ng-container>
                                            <ng-container *ngIf="searchedArticles['articles']?.length > 0">
                                                <div class="bordered-text">{{'app_header.article'|translate}}</div>
                                                <li *ngFor="let list of searchedArticles['articles']">
                                                    <div data-bs-dismiss="offcanvas" class="search-article-title"
                                                        [routerLink]="['/articles/'+list.volume+'/'+list.issue+'/'+list.article_id]"
                                                        [innerHTML]="list.article_title | stripFootnote | highlightSearch : searchData.searchValue.value"
                                                        tabindex="0">
                                                    </div>
                                                    <div class="nav-search-doi"
                                                        [innerHTML]="list.doi | highlightSearch : searchData.searchValue.value"
                                                        tabindex="0">
                                                    </div>
                                                    <span class='activeSemicolumn' *ngFor="let authors of list.authors"
                                                        tabindex="0"
                                                        [innerHTML]="authors.first_name + ' ' + authors.last_name | highlightSearch : searchData.searchValue.value"></span>
                                                </li>
                                            </ng-container>
                                            <!-- <ng-container *ngIf="searchedArticles['articles']?.length ===0 && !loading">
                                                <li>
                                                    <div
                                                        style="display: flex; flex-direction: column; align-items: center; padding-bottom: 5px;">
                                                        <img class="no-data-found-img" src="assets/images/not_found_img/no_data_1.png"
                                                            alt="">
                                                        <h5 class="card-title  text-head-size">No Data
                                                            Found</h5>
                                                    </div>
                                                </li>
                                            </ng-container>
                                            <ng-container *ngIf="noData">
                                                <li>
                                                    <div
                                                        style="display: flex; flex-direction: column; align-items: center; padding-bottom: 5px;">
                                                        <img class="no-data-found-img"
                                                            src="assets/images/not_found_img/no_data_1.webp" alt="">
                                                        <h5 class="card-title  text-head-size">No Data Found
                                                        </h5>
                                                    </div>
                                                </li>
                                            </ng-container>-->
                                        </ul>
                                    </div>
                                </form>
                            </div>

                            <div
                                class="user-account-sec d-flex pr-2 primary-header media-icon align-items-center  d-none d-lg-block">
                                <!-- Media icons content here 
                                <div class="user-account-sec d-flex  primary-header media-icon">
                                    <ng-container
                                        *ngIf="returnSocialMedia(journalSettingData).length>0 && socialmediaicon">
                                        <a *ngFor="let media of returnSocialMedia(journalSettingData)"
                                            class="navbar-brand navbar-brand-secondary-icons" target="_blank"
                                            [href]="ensureHttps(media.value)" role="link" title="{{media.label}}"
                                            [attr.aria-label]="'vist link'+ media.value" [ngbTooltip]="media.label"
                                            [placement]="'bottom'">
                                            <fa-icon aria-hidden="true" [icon]="media.icon"></fa-icon>
                                        </a>
                                    </ng-container>--->

                                <a class=" media-content-rss" [href]="rss_url" target="_blank" role="link"
                                    aria-label="RSS feed" v title="RSS Feed"
                                    [ngbTooltip]="'app_header.rss_feed'|translate" [placement]="'bottom'">
                                    <fa-icon aria-hidden="true" [icon]="['fas','square-rss']"></fa-icon>
                                </a>

                                <!--</div>
                                <div *ngIf="temporary_value" class="user-account-sec d-flex pr-4 primary-header">


                                    <div class="user" *ngIf="!islogined">
                                        <fa-icon aria-hidden="true" [icon]="['far', 'user']"
                                            class="user-icon-size "></fa-icon>
                                    </div>

                                    <div class="umc-avatar-container ud-component--user-manage--avatar"
                                        *ngIf="islogined">
                                        <img [src]="profile_picture" alt="'app_header.profile_picture'|translate"
                                            class="user_image">
                                    </div>

                                    <div class="user-info" (click)="openLoginModal()" (keyup.enter)="openLoginModal()"
                                        (keyup.space)="openLoginModal()" *ngIf="!islogined" tabindex="0">
                                        <p class="user-sign-in cursor-pointer">{{ 'app_header.sign_in' | translate }}
                                        </p>
                                        <p class="user-account cursor-pointer">{{ 'app_header.account' | translate }}
                                        </p>
                                    </div>

                                    <div class="user-info cursor-pointer" *ngIf="islogined" tabindex="0">
                                        <p style="margin-bottom:0px">{{ fullName }}</p>
                                        <p class="user-account" (click)="openProfile()" (keyup.enter)="openProfile()"
                                            (keyup.space)="openProfile()">{{ 'app_header.account' | translate }}</p>
                                    </div>
                                </div>

                                <div *ngIf="temporary_value" class="user-account-sec d-flex pr-4 primary-header">
                                    <div class="user" *ngIf="islogined" (click)="userLogout()"
                                        (keyup.enter)="userLogout()" tabindex="0">
                                        <fa-icon aria-hidden="true" [icon]="['fas', 'right-from-bracket']"
                                            class="user-icon-size"></fa-icon>
                                    </div>
                                </div>

                                <div *ngIf="temporary_value" role="link"
                                    [attr.aria-label]="'aria_label.wishlist'|translate"
                                    class="user-wishlist-icon pr-4 primary-header" tabindex="0">
                                    <fa-icon icon="heart" aria-hidden="true" class="user-icon-size "></fa-icon>
                                </div>
                                <div *ngIf="temporary_value" role="link" [attr.aria-label]="'aria_label.cart'|translate"
                                    class="user-cart d-flex flag-margin pr-4 primary-header" tabindex="0">
                                    <fa-icon aria-hidden="true" icon="cart-shopping" class="user-icon-size"></fa-icon>
                                    <span class="cart-count"> {{ itemsInCart }}</span>
                                </div>-->
                                <div *ngIf="temporary_value"
                                    class="respncive-nav-head-content pl-4 d-flex rvh-lang-sec primary-header">
                                    <div class="dropdown">
                                        <span role="button" tabindex="0" title="Language"
                                            [attr.aria-label]="'aria_label.language'|translate" aria-haspopup="listbox"
                                            data-bs-toggle="dropdown" aria-expanded="false" id="dropdownLanguage"
                                            class="padding-to-options rvh-lang-flag" aria-expanded="false">
                                            <span class="fi fi-{{currentCountryCode}} size"></span>
                                        </span>
                                        <ul class="dropdown-menu" role="listbox" aria-labelledby="dropdownLanguage"
                                            aria-expanded="false">

                                            <li style="cursor:pointer;" role="option"
                                                *ngFor="let language of activeLanguages"
                                                class="nav-list rvhws-language-list p-1" tabindex="0"
                                                [attr.aria-label]="language.language_name">
                                                <span class="padding pl-2" value="language.country_language_code"
                                                    title="{{language.language_name}}"
                                                    (click)="changeSiteLanguage(language.country_language_code)"
                                                    (keyup.enter)="changeSiteLanguage(language.country_language_code)"
                                                    (keyup.space)="changeSiteLanguage(language.country_language_code)"><span
                                                        style="margin-left: 2px;"
                                                        class="fi fi-{{returnCountryCode(language.country_language_code)}}"></span>
                                                </span>
                                                <span (click)="changeSiteLanguage(language.country_language_code)"
                                                    (keyup.enter)="changeSiteLanguage(language.country_language_code)"
                                                    (keyup.space)="changeSiteLanguage(language.country_language_code)"
                                                    class="pl-2">{{language.language_name}}
                                                    (<small>{{language.country_name}}</small>)</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-lg-4 col-md-12 col-sm-12 ">
                        <div class="d-flex header-search-and-social-media-section">
                            <div class="search-div-header d-none d-lg-block">
                                <form class="form-inline " [formGroup]="searchForm" role="search">
                                    <div class="input-group search-box primary-header search-content">
                                        <div class="search-icon-div">
                                            <span id="basic-addon1">
                                                <fa-icon [icon]="['fas','magnifying-glass']" aria-hidden="true" ></fa-icon>
                                            </span>
                                        </div>
                                        <input type="text" class="form-control search-box-input-control mt-0 search-input-header"
                                            autocomplete="off" name="searchValue"
                                            placeholder="{{'app_header.search_placeholder_jba'|translate }}"
                                            formControlName="searchValue" (keyup)="searchArticle()"
                                            (keyup.enter)="loadArticlePage()" (click)="searchArticle()"
                                            data-bs-toggle="dropdown" id="dropdownMenuButton"
                                            (focusout)="searchLoader = false;">
                                        <span class="closeMark" *ngIf="!searchLoader && searchData?.searchValue?.value"
                                            (click)="clearSearch()" (keyup.enter)="clearSearch()"
                                            (keyup.space)="clearSearch()" tabindex="0">
                                            <fa-icon aria-hidden="true" [icon]="['fas', 'xmark']" class=""></fa-icon>
                                        </span>
                                        <div *ngIf="searchLoader">
                                            <div class="spinner-border"></div>
                                        </div>
                                        <ul class="search-dropdown dropdown-menu" style="left: -2rem;" role="search">
                                            <ng-container *ngIf="loading">
                                                <li>
                                                    <div class="search-article-title loader" tabindex="0">
                                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    </div>
                                                    <div class="nav-search-doi loader" style="width: 50%;" tabindex="0">
                                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    </div>
                                                    <span class='activeSemicolumn loader' style="width: 25%;"
                                                        tabindex="0">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                </li>
                                                <li>
                                                    <div class="search-article-title loader" tabindex="0">
                                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    </div>
                                                    <div class="nav-search-doi loader" style="width: 50%;" tabindex="0">
                                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    </div>
                                                    <span class='activeSemicolumn loader' style="width: 25%;"
                                                        tabindex="0">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                </li>
                                            </ng-container>
                                            <ng-container *ngIf="searchedArticles['articles']?.length > 0">
                                                <div class="bordered-text">{{'app_header.article'|translate}}</div>
                                                <li *ngFor="let list of searchedArticles['articles']">
                                                    <div data-bs-dismiss="offcanvas" class="search-article-title"
                                                        [routerLink]="['/articles/'+list.volume+'/'+list.issue+'/'+list.article_id]"
                                                        [innerHTML]="list.article_title | stripFootnote | highlightSearch : searchData.searchValue.value"
                                                        tabindex="0">
                                                    </div>
                                                    <div class="nav-search-doi"
                                                        [innerHTML]="list.doi | highlightSearch : searchData.searchValue.value"
                                                        tabindex="0">
                                                    </div>
                                                    <span class='activeSemicolumn' *ngFor="let authors of list.authors"
                                                        tabindex="0"
                                                        [innerHTML]="authors.first_name + ' ' + authors.last_name | highlightSearch : searchData.searchValue.value"></span>
                                                </li>
                                            </ng-container>
                                            <!-- <ng-container *ngIf="searchedArticles['articles']?.length ===0 && !loading">
                                                <li>
                                                    <div
                                                        style="display: flex; flex-direction: column; align-items: center; padding-bottom: 5px;">
                                                        <img class="no-data-found-img" src="assets/images/not_found_img/no_data_1.png"
                                                            alt="">
                                                        <h5 class="card-title  text-head-size">No Data
                                                            Found</h5>
                                                    </div>
                                                </li>
                                            </ng-container>
                                            <ng-container *ngIf="noData">
                                                <li>
                                                    <div
                                                        style="display: flex; flex-direction: column; align-items: center; padding-bottom: 5px;">
                                                        <img class="no-data-found-img"
                                                            src="assets/images/not_found_img/no_data_1.webp" alt="">
                                                        <h5 class="card-title  text-head-size">No Data Found
                                                        </h5>
                                                    </div>
                                                </li>
                                            </ng-container>
                                        </ul>
                                    </div>
                                </form>
                            </div>

                            <div
                                class="user-account-sec d-flex pr-2 primary-header media-icon align-items-center  d-none d-lg-block">
                                <!-- Media icons content here 
                                <div class="user-account-sec d-flex  primary-header media-icon">
                                    <ng-container
                                        *ngIf="returnSocialMedia(journalSettingData).length>0 && socialmediaicon">
                                        <a *ngFor="let media of returnSocialMedia(journalSettingData)"
                                            class="navbar-brand navbar-brand-secondary-icons" target="_blank"
                                            [href]="ensureHttps(media.value)" role="link" title="{{media.label}}"
                                            [attr.aria-label]="'vist link'+ media.value" [ngbTooltip]="media.label"
                                            [placement]="'bottom'">
                                            <fa-icon aria-hidden="true" [icon]="media.icon"></fa-icon>
                                        </a>
                                    </ng-container>

                                    <a *ngIf="socialmediaicon"
                                        class="navbar-brandnavbar-brand-secondary-icons media-content-rss"
                                        [href]="rss_url" target="_blank" role="link" aria-label="RSS feed"
                                        title="RSS Feed" [ngbTooltip]="'app_header.rss_feed'|translate"
                                        [placement]="'bottom'">
                                        <fa-icon aria-hidden="true" [icon]="['fas','square-rss']"></fa-icon>
                                    </a>

                                </div>
                                <div *ngIf="temporary_value" class="user-account-sec d-flex pr-4 primary-header">


                                    <div class="user" *ngIf="!islogined">
                                        <fa-icon aria-hidden="true" [icon]="['far', 'user']"
                                            class="user-icon-size "></fa-icon>
                                    </div>

                                    <div class="umc-avatar-container ud-component--user-manage--avatar"
                                        *ngIf="islogined">
                                        <img [src]="profile_picture" alt="'app_header.profile_picture'|translate"
                                            class="user_image">
                                    </div>

                                    <div class="user-info" (click)="openLoginModal()" (keyup.enter)="openLoginModal()"
                                        (keyup.space)="openLoginModal()" *ngIf="!islogined" tabindex="0">
                                        <p class="user-sign-in cursor-pointer">{{ 'app_header.sign_in' | translate }}
                                        </p>
                                        <p class="user-account cursor-pointer">{{ 'app_header.account' | translate }}
                                        </p>
                                    </div>

                                    <div class="user-info cursor-pointer" *ngIf="islogined" tabindex="0">
                                        <p style="margin-bottom:0px">{{ fullName }}</p>
                                        <p class="user-account" (click)="openProfile()" (keyup.enter)="openProfile()"
                                            (keyup.space)="openProfile()">{{ 'app_header.account' | translate }}</p>
                                    </div>
                                </div>

                                <div *ngIf="temporary_value" class="user-account-sec d-flex pr-4 primary-header">
                                    <div class="user" *ngIf="islogined" (click)="userLogout()"
                                        (keyup.enter)="userLogout()" tabindex="0">
                                        <fa-icon aria-hidden="true" [icon]="['fas', 'right-from-bracket']"
                                            class="user-icon-size"></fa-icon>
                                    </div>
                                </div>

                                <div *ngIf="temporary_value" role="link"
                                    [attr.aria-label]="'aria_label.wishlist'|translate"
                                    class="user-wishlist-icon pr-4 primary-header" tabindex="0">
                                    <fa-icon icon="heart" aria-hidden="true" class="user-icon-size "></fa-icon>
                                </div>
                                <div *ngIf="temporary_value" role="link" [attr.aria-label]="'aria_label.cart'|translate"
                                    class="user-cart d-flex flag-margin pr-4 primary-header" tabindex="0">
                                    <fa-icon aria-hidden="true" icon="cart-shopping" class="user-icon-size"></fa-icon>
                                    <span class="cart-count"> {{ itemsInCart }}</span>
                                </div>
                                <div *ngIf="temporary_value"
                                    class="respncive-nav-head-content pl-4 d-flex rvh-lang-sec primary-header">
                                    <div class="dropdown">
                                        <span role="button" tabindex="0" title="Language"
                                            [attr.aria-label]="'aria_label.language'|translate" aria-haspopup="listbox"
                                            data-bs-toggle="dropdown" aria-expanded="false" id="dropdownLanguage"
                                            class="padding-to-options rvh-lang-flag" aria-expanded="false">
                                            <span class="fi fi-{{currentCountryCode}} size"></span>
                                        </span>
                                        <ul class="dropdown-menu" role="listbox" aria-labelledby="dropdownLanguage"
                                            aria-expanded="false">

                                            <li style="cursor:pointer;" role="option"
                                                *ngFor="let language of activeLanguages"
                                                class="nav-list rvhws-language-list p-1" tabindex="0"
                                                [attr.aria-label]="language.language_name">
                                                <span class="padding pl-2" value="language.country_language_code"
                                                    title="{{language.language_name}}"
                                                    (click)="changeSiteLanguage(language.country_language_code)"
                                                    (keyup.enter)="changeSiteLanguage(language.country_language_code)"
                                                    (keyup.space)="changeSiteLanguage(language.country_language_code)"><span
                                                        style="margin-left: 2px;"
                                                        class="fi fi-{{returnCountryCode(language.country_language_code)}}"></span>
                                                </span>
                                                <span (click)="changeSiteLanguage(language.country_language_code)"
                                                    (keyup.enter)="changeSiteLanguage(language.country_language_code)"
                                                    (keyup.space)="changeSiteLanguage(language.country_language_code)"
                                                    class="pl-2">{{language.language_name}}
                                                    (<small>{{language.country_name}}</small>)</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->
                </nav>
            </div>
        </div>
    </div>
</nav>
<div class="search-container d-flex d-lg-none justify-content-center   search-bar-section" *ngIf="showSearchBarTextBox">

    <form class="form-inline " [formGroup]="searchForm" role="search">
        <div class="input-group search-box primary-header search-content">
            <div class="search-icon-div">
                <span id="basic-addon1">
                    <!-- <i class="bi bi-search"></i> -->
                    <fa-icon [icon]="['fas','magnifying-glass']" aria-hidden="true"></fa-icon>
                </span>
            </div>
            <input type="text" class="form-control search-box-input-control " autocomplete="off"
                placeholder="{{'app_header.search_placeholder_jba'|translate }}" name="searchValue"
                formControlName="searchValue" (keyup)="searchArticle()" (click)="searchArticle()"
                data-bs-toggle="dropdown" id="dropdownMenuButton1" (focusout)="searchLoader = false;"
                (keyup.enter)="loadArticlePage()" tabindex="0">
            <span class="closeMark" *ngIf="!searchLoader && searchData?.searchValue?.value" (click)="clearSearch()"
                (keyup.enter)="clearSearch()" (keyup.space)="clearSearch()" tabindex="0">
                <fa-icon aria-hidden="true" [icon]="['fas', 'xmark']" class=""></fa-icon>
            </span>
            <div *ngIf="searchLoader">
                <div class="spinner-border"></div>
            </div>
            <ul class="search-dropdown dropdown-menu" style="left: -2rem;" role="search">
                <ng-container *ngIf="loading">
                    <li>
                        <div class="search-article-title loader" tabindex="0">
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </div>
                        <div class="nav-search-doi loader" style="width: 50%;" tabindex="0">
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </div>
                        <span class='activeSemicolumn loader' style="width: 25%;"
                            tabindex="0">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    </li>
                    <li>
                        <div class="search-article-title loader" tabindex="0">
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </div>
                        <div class="nav-search-doi loader" style="width: 50%;" tabindex="0">
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </div>
                        <span class='activeSemicolumn loader' style="width: 25%;"
                            tabindex="0">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    </li>
                </ng-container>
                <ng-container *ngIf="searchedArticles['articles']?.length > 0">
                    <div class="bordered-text">{{'app_header.article'|translate}}</div>
                    <li *ngFor="let list of searchedArticles['articles']">
                        <div class="search-article-title" data-bs-dismiss="offcanvas"
                            [routerLink]="['/articles/'+list.volume+'/'+list.issue+'/'+list.article_id]"
                            [innerHTML]="list.article_title | stripFootnote | highlightSearch : searchData.searchValue.value"
                            tabindex="0">
                        </div>
                        <div class="nav-search-doi"
                            [innerHTML]="list.doi | highlightSearch : searchData.searchValue.value" tabindex="0">
                        </div>
                        <span class='activeSemicolumn' *ngFor="let authors of list.authors" tabindex="0"
                            [innerHTML]="authors.first_name + ' ' + authors.last_name | highlightSearch : searchData.searchValue.value"></span>
                    </li>
                </ng-container>
                <hr class="divider"
                    *ngIf="searchedArticles['articles']?.length > 0 && searchedArticles['books']?.length > 0">
                <ng-container *ngIf="searchedArticles['books']?.length > 0">
                    <div class="bordered-text"> {{'app_header.books' |translate}}</div>
                    <li *ngFor="let book of searchedArticles['books']">
                        <div class="search-article-title" data-bs-dismiss="offcanvas"
                            [routerLink]="['/book/'+book.bk_book_id]" tabindex="0"
                            [innerHTML]="book.bk_title | highlightSearch : searchData.searchValue.value">
                        </div>
                        <div class="nav-search-doi"
                            [innerHTML]="book.bk_doi | highlightSearch : searchData.searchValue.value">
                        </div>
                        <span class='activeSemicolumn' *ngFor="let authors of book.bk_authors" tabindex="0"
                            [innerHTML]="authors.surname + ' ' + authors.givenname | highlightSearch : searchData.searchValue.value">
                        </span>
                    </li>
                </ng-container>
                <hr class="divider"
                    *ngIf="(searchedArticles['articles']?.length > 0 && searchedArticles['journals']?.length > 0) || (searchedArticles['books']?.length > 0 && searchedArticles['journals']?.length > 0)">
                <ng-container *ngIf="searchedArticles['journals']?.length > 0">
                    <div class="bordered-text"> {{'app_header.journals' | translate}}</div>
                    <li *ngFor="let journal of searchedArticles['journals']" tabindex="0">
                        <div class="search-article-title" [routerLink]="['']" data-bs-dismiss="offcanvas"
                            [innerHTML]="journal.jnl_title | highlightSearch : searchData.searchValue.value">
                        </div>
                    </li>
                </ng-container>
                <ng-container *ngIf="noData">
                    <li>
                        <div style="display: flex; flex-direction: column; align-items: center; padding-bottom: 5px;">
                            <img class="no-data-found-img" src="assets/images/not_found_img/no_data_1.webp" alt="">
                            <h5 class="card-title  text-head-size">No Data Found
                            </h5>
                        </div>
                    </li>
                </ng-container>
            </ul>
        </div>
    </form>
</div>
<nav aria-label="" class="navbar navbar-expand-lg navbar-light navigation-primary-bar mt-2 header-section d-none">
    <div class="collapse navbar-collapse d-flex justify-content-between" id="navbarNav">
        <ul class="navbar-nav flex-1">
            <li class="nav-item nav-item-primary-width active d-flex justify-content-center flex-1">
                <a class="nav-link nav-link-primary" role="link" routerLink="/home"
                    title="{{'app_header.home' | translate}}">{{'app_header.home' | translate}}
                </a>
            </li>
            <li *ngIf="is_exist_about" class="nav-item nav-item-primary-width d-flex justify-content-center flex-1">
                <a class="nav-link nav-link-primary" role="link" [routerLink]="publisher_id+'/content/'+ aboutPageId"
                    title="{{'app_header.about' | translate}}">
                    {{'app_header.about' | translate}}
                </a>
            </li>
            <li *ngIf="journalData.length > 0"
                class="nav-item nav-item-primary-width d-flex justify-content-center flex-1">
                <a class="nav-link nav-link-primary" routerLink="/journals"
                    title="{{'app_header.journals' | translate}}">
                    {{'app_header.journals' | translate}}
                </a>
            </li>
            <li *ngIf="books_value.length > 0"
                class="nav-item nav-item-primary-width d-flex justify-content-center flex-1">
                <a class="nav-link nav-link-primary" routerLink="/books"
                    title="{{'app_header.books' | translate}}">{{'app_header.books' | translate}}</a>
            </li>
            <li *ngIf="dynamicMenuData" class="nav-item nav-item-primary-width d-flex justify-content-center flex-1"
                (click)="getDynamicMenusJournal(publisher_id)">
                <div class="dropdown">
                    <span class=" dropdown-toggle nav-link-primary" href="#" role="button" id="dropdownMenuLinkMore1"
                        title=" {{'app_header.more' | translate}}" data-bs-toggle="dropdown" aria-expanded="false" tabindex="0">
                        {{'app_header.more' | translate}}
                    </span>
                    <ul class="dropdown-menu" aria-labelledby="dropdownMenuLinkMore1">
                        <li *ngFor="let data of dynamic_menus">
                            <a class="dropdown-item" title="{{data.pageName}}"
                                [routerLink]="publisher_id+'/content/'+data.page_identifier">{{data.pageName}}</a>
                        </li>

                    </ul>
                </div>
            </li>
        </ul>
    </div>
</nav>

<nav aria-label="" class="navbar navbar-expand-lg navbar-light secondary-navigation-header header-section"
    *ngIf="secondNavigation && temporary_value">
    <!-- <img src="{{returnJournalLogo(journalSettingData)}}" tabindex="0" class="secondary-header-logo"
        *ngIf="!secondNavigationBook" [alt]="journalSettingData.logo_alt_text"> -->
    <span class="navbar-brand navbar-brand-secondary " title=" {{journalSettingData.journal_display_name}}"
        *ngIf="!secondNavigationBook && journalSettingData && journalSettingData.journal_display_name">
        {{journalSettingData.journal_display_name}}
    </span>
    <div class="collapse navbar-collapse d-flex justify-content-between" id="navbarNav">
        <ul class="navbar-nav flex-1 rvh-journal-prime-nav">

            <li role="link"
                class="nav-item nav-item-secondary d-flex justify-content-center nav-item-secondary-hide-responsive flex-1">
                <a class="nav-link nav-link-secondary" [routerLink]="['']" title="{{'app_header.home' | translate}}">
                    {{'app_header.home' | translate}}
                </a>
            </li>

            <li *ngIf="is_exist_about_journal" role="link"
                class="nav-item nav-item-secondary d-flex justify-content-center nav-item-secondary-hide-responsive flex-1">
                <a class="nav-link nav-link-secondary" [routerLink]="'/content/'+aboutPageId"
                    title="{{'app_header.about' | translate}}">
                    {{'app_header.about' | translate}}
                </a>
            </li>

            <li class="nav-item nav-item-secondary d-flex justify-content-center nav-item-secondary-hide-responsive flex-1"
                *ngIf="!secondNavigationBook && volumeData.length > 0" role="link">
                <a class="nav-link nav-link-secondary" [routerLink]="['volumes' ]" title="{{'app_header.volume' |
                translate}}">
                    {{'app_header.volume' | translate}}</a>
            </li>

            <li class="nav-item nav-item-secondary d-flex justify-content-center nav-item-secondary-hide-responsive flex-1"
                *ngIf="!secondNavigationBook && articleList.length > 0 ||fastTrackList.length>0" role="link">
                <a class="nav-link nav-link-secondary" [routerLink]="['articles', 'page', 1 ]"
                    title="{{'app_header.article' | translate}}">{{'app_header.article' | translate}}</a>
            </li>

            <li class="nav-item nav-item-secondary d-flex justify-content-center nav-item-secondary-hide-responsive flex-1"
                *ngIf="!secondNavigationBook">
                <a class="nav-link nav-link-secondary" href="#" title="{{'app_header.submit_article'|translate}}"
                    role="link">{{'app_header.submit_article'|translate}}</a>
            </li>
            <li
                class="nav-item nav-item-secondary d-flex justify-content-center nav-item-secondary-hide-responsive flex-4">
                <div class="dropdown" (click)="getDynamicMenusJournal(journalId)">
                    <span class="dropdown-toggle nav-link-secondary" role="link" id="dropdownMenuLinkMore2" tabindex="0"
                        data-bs-toggle="dropdown" aria-expanded="false" title="{{'app_header.more' | translate}}">
                        {{'app_header.more' | translate}}
                    </span>
                    <ul *ngIf="dynamic_menu_journal_status===true" class="dropdown-menu" role="listbox"
                        aria-labelledby="dropdownMenuLinkMore2">
                        <li *ngFor="let data of dynamic_menus_journal" role="option">
                            <a class="dropdown-item" tabindex="0" [attr.aria-label]="data.pageName"
                                [routerLink]="['/content/'+ data.page_identifier]"
                                title="{{data.pageName}}">{{data.pageName}}</a>
                        </li>
                        <li>
                            <a class="dropdown-item" *ngIf="contactStatus===true" tabindex="0"
                                [routerLink]="['/contact/']" title="Contact Us">Contact Us</a>
                        </li>
                    </ul>
                </div>
            </li>
        </ul>


        <div class="nav-item-secondary-responsive">
            <ul class="nav-item nav-item-secondary d-flex justify-content-center rvh-journal-prime-nav">
                <li class="dropdown">
                    <span class=" dropdown-toggle nav-link-primary" tabindex="0" role="button"
                        id="dropdownMenuLinkToggle" data-bs-toggle="dropdown" aria-expanded="false" title="Breadcrumb">
                        <fa-icon class="iconcls" aria-hidden="true" [icon]="['fas', 'bars']"></fa-icon>
                    </span>
                    <ul class="dropdown-menu" aria-labelledby="dropdownMenuLinkToggle" *ngIf="journalIdLoaded">
                        <li><span class="dropdown-item pl-3" role="link" tabindex="0"
                                title="{{'app_header.home' | translate}}">
                                {{'app_header.home' | translate}}
                            </span></li>
                        <li *ngIf="is_exist_about_journal"><a class="dropdown-item" role="link"
                                [routerLink]="publisher_id+'/content/'+aboutPageId"
                                title=" {{'app_header.about'|  translate}}">
                                {{'app_header.about'| translate}}
                            </a></li>
                        <li *ngIf="!secondNavigationBook && volumeData.length > 0"><a class="dropdown-item" role="link"
                                [routerLink]="[ 'volumes' ]" title=" {{'app_header.volume' |  translate}}">
                                {{'app_header.volume' | translate}}
                            </a></li>
                        <li *ngIf="!secondNavigationBook && articleList.length > 0"><a class="dropdown-item" role="link"
                                [routerLink]="[ 'articles', 'page', 1 ]">{{'app_header.article' |
                                translate}}</a></li>
                        <li *ngIf="!secondNavigationBook"><span class="dropdown-item pl-3" role="link"
                                title=" {{'app_header.submit_article' | translate}}" tabindex="0">
                                {{'app_header.submit_article' | translate}}
                            </span></li>
                        <li *ngIf="journalDynamicData.length > 0" (click)="getDynamicMenusJournal(journalId)"
                            (keyup.ArrowDown)="getDynamicMenusJournal(journalId)"
                            (keyup.enter)="getDynamicMenusJournal(journalId)">
                            <span class="dropdown-item" tabindex="0" title=" {{'app_header.more' | translate}}">
                                <div class="dropdown"><span class=" dropdown-toggle nav-link-secondary" tabindex="0"
                                        role="button" id="dropdownMenuLinkMore3" data-bs-toggle="dropdown"
                                        aria-expanded="false">
                                        {{'app_header.more' | translate}}
                                    </span>
                                    <ul *ngIf="dynamic_menus_journal.length > 0" class="dropdown-menu"
                                        aria-labelledby="dropdownMenuLinkMore3">
                                        <li *ngFor="let data of dynamic_menus">
                                            <a class="dropdown-item" role="link" title="{{data.pageName}}"
                                                [routerLink]="journalId+'/content/'+data.page_identifier">{{data.pageName}}</a>
                                        </li>
                                    </ul>
                                </div>
                            </span>
                        </li>
                    </ul>
                </li>
            </ul>

        </div>
    </div>

</nav>
<nav *ngIf="temporary_value && secondNavigation" aria-label=""
    class="navbar navbar-expand-lg navbar-light secondary-navigation-header header-section" style="z-index: -3 !important; box-shadow: 0px 0px 10px 0px rgba(0,0,0,.2);
    background: #fff !important;">
    <div class="collapse navbar-collapse d-flex justify-content-between" id="navbarNav">
        <ul class="navbar-nav flex-1 rvh-journal-sec-nav">
            <div class="ml-5">
                <div class="row">
                    <div class="col-12">
                        <span
                            style="font-size: 14px; text-transform: uppercase;font-weight: bold; color:{{navprimarycolor}};">
                            {{articleList[0].journal_title}}
                        </span>

                    </div>
                </div>
            </div>
        </ul>
        <ng-container *ngIf="returnSocialMedia(journalSettingData).length>0">
            <a *ngFor="let media of returnSocialMedia(journalSettingData)"
                class="navbar-brand navbar-brand-secondary-icons m-0" href="{{media.value}}" role="link"
                [attr.aria-label]="'vist link'+ media.value">
                <fa-icon aria-hidden="true" [icon]="media.icon"></fa-icon>
            </a>
        </ng-container>
    </div>
</nav>
<!-- <div class="container-fulid navbar-brand-secondary-responsive header-section" *ngIf="secondNavigation">
    <div class="row">
        <div class="col nav-image">
        </div>
        <div class="col d-flex justify-content-center nav-social-links">
            <a class="navbar-brand navbar-brand-secondary-icons m-0" aria-label="twitter">
                <fa-icon aria-hidden="true" [icon]="['fab', 'twitter']"></fa-icon>
            </a>
            <a class="navbar-brand navbar-brand-secondary-icons m-0" aria-label="youtube">
                <fa-icon aria-hidden="true" [icon]="['fab', 'youtube']"></fa-icon>
            </a>
            <a class="navbar-brand navbar-brand-secondary-icons m-0" aria-label="dropbox">
                <fa-icon aria-hidden="true" [icon]="['fab', 'dropbox']"></fa-icon>
            </a>
        </div>
        <div class="col nav-dropdown-menu d-flex justify-content-end">
            <nav class="responsive-last-header-nav" aria-label="">
                <ul class="responsive-last-header-ul dropleft">
                    <li class="responsive-last-header-li">
                        <a href="#">
                            <fa-icon class="iconcls" aria-hidden="true" [icon]="['fas', 'bars']"></fa-icon>
                        </a>
                        <ul class="responsive-last-header-ul">
                            <li class="responsive-last-header-li"><a tabindex="0" role="link"> {{'app_header.home' |
                                    translate}}</a>
                            </li>
                            <li *ngIf="is_exist_about_journal" class="responsive-last-header-li">
                                <a [routerLink]="'/journal'+'/'+journalId+'/content/'+aboutPageId"
                                    role="link">{{'app_header.about' |
                                    translate}}</a>
                            </li>
                            <li *ngIf="!secondNavigationBook && volumeData.length > 0"
                                class="responsive-last-header-li"><a [routerLink]="['/journal/',journalId, 'volumes' ]"
                                    role="link" tabindex="0">
                                    {{'app_header.volume' | translate}}</a>
                            </li>
                            <li *ngIf="!secondNavigationBook && articleList.length > 0"
                                class="responsive-last-header-li"><a tabindex="0" role="link"
                                    [routerLink]="['/journal/',journalId, 'articles', 'page', 1 ]">
                                    {{'app_header.article' | translate}}</a>
                            </li>
                            <li class="responsive-last-header-li" aria-label="submit article"><a tabindex="0"
                                    role="link"> {{'app_header.submit_article' |
                                    translate}}</a></li>
                            <li *ngIf="journalDynamicData && journalDynamicData.length > 0"
                                class="responsive-last-header-li">
                                <a tabindex="0" role="button" (keyup.ArrowDown)="getDynamicMenusJournal(journalId)"
                                    (keyup.enter)="getDynamicMenusJournal(journalId)"
                                    (click)="getDynamicMenusJournal(journalId)">{{'app_header.more' |
                                    translate}}</a>
                                <ul *ngIf="dynamic_menus_journal && dynamic_menus_journal.length > 0"
                                    class="responsive-last-header-ul">
                                    <li class="responsive-last-header-li" *ngFor="let data of dynamic_menus_journal"><a
                                            tabindex="0"
                                            [routerLink]="['/journal/'+journalId+ '/content/'+ data.pageId]">{{data.pageName}}</a>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</div> -->